import { convertToHash } from './convertToHash';

export const SHORT_HASH_MINIMUM = 0;
export const SHORT_HASH_MAXIMUM = 10;

export const shortenedHashOf = (input: string) => {
  const inputLong = convertToHash(input);
  return inputLong.substring(SHORT_HASH_MINIMUM, SHORT_HASH_MAXIMUM);
};
